/* Essence: quick add on product tiles. The + opens the sizes on the tile; a size goes into the bag
   and the theme's own cart flow (on:cart:change) refreshes the header and opens the cart drawer. */
(function () {
  var SCOPE = '.image-cont, .upsell-tile__top'; // product tiles, cart drawer tiles
  function closeAll(except) {
    document.querySelectorAll('.ess-qa:not([hidden])').forEach(function (p) {
      if (p !== except) { p.hidden = true; p.closest(SCOPE).classList.remove('ess-qa-open'); }
    });
  }

  function add(id, el) {
    el.classList.add('is-loading');
    return fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      closeAll();
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: Number(id) } }));
      if (window.theme && theme.settings && theme.settings.afterAddToCart === 'page') { window.location.href = theme.routes.cart; return; }
      // Open the drawer once it has re-rendered with the new item (fallback after 1.5 s)
      var opened = false;
      var open = function () {
        if (opened) return;
        opened = true;
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: el } }));
      };
      document.addEventListener('on:cart:after-merge', open, { once: true });
      setTimeout(open, 1500);
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    }).finally(function () { el.classList.remove('is-loading'); });
  }

  window.essQA = function (evt, btn) {
    var mode = btn.dataset.qa;
    if (mode === 'link' || !mode) return; // normal link to the product page
    evt.preventDefault();
    if (mode === 'add') {
      add(btn.dataset.variantId, btn).catch(function () { window.location.href = btn.href; });
      return;
    }
    var cont = btn.closest(SCOPE);
    var panel = cont && cont.querySelector('.ess-qa');
    if (!panel) { var a = cont && cont.querySelector('a[href]'); if (a) window.location.href = a.href; return; }
    closeAll(panel);
    panel.hidden = false;
    cont.classList.add('ess-qa-open');
  };

  window.essQAPanel = function (evt) {
    var opt = evt.target.closest('.ess-qa__opt');
    if (opt && !opt.disabled) {
      var link = opt.closest(SCOPE).querySelector('a[href]');
      add(opt.dataset.variantId, opt).catch(function () { if (link) window.location.href = link.href; });
    } else if (evt.target.closest('.ess-qa__close')) {
      closeAll();
    }
  };

  // A click anywhere else closes an open size panel
  document.addEventListener('click', function (evt) {
    if (!evt.target.closest('.ess-qa')) closeAll();
  });

  document.addEventListener('keydown', function (evt) { if (evt.key === 'Escape') closeAll(); });
})();
